import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Button, Checkbox } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useState } from "react";
import { CSVLink } from "react-csv";
import "../ReportsDetailed.css";
import { BreadcrumbAdmin } from "../../../../UI/BreadcrumbAdmin";
import DateRangePickerComp from "../../../../UI/DateRangePicker";
import { CompanyWiseBreakdownTable } from "./CompanyWiseBreakdownTable";
import { useOutsideClick } from "../../../../../hooks/useOutsideClick";

const list = [
  { name: "company", label: "Company" },
  { name: "totalEmployees", label: "Total Employees" },
  { name: "active", label: "Active" },
  { name: "inactive", label: "Inactive" },
  { name: "activePercent", label: "Active %" },
  { name: "totalPtsEarned", label: "Total Pts Earned" },
  { name: "ptsRedeemed", label: "Pts Redeemed" },
  { name: "balancePts", label: "Balance Pts" },
  { name: "totalAdmins", label: "Total Admins" },
];

const padDateUnit = (value) => String(value).padStart(2, "0");

const toIsoDatePart = (date) => {
  const selectedDate = new Date(date);
  const year = selectedDate.getFullYear();
  const month = padDateUnit(selectedDate.getMonth() + 1);
  const day = padDateUnit(selectedDate.getDate());
  return `${year}-${month}-${day}`;
};

const toUtcDayStartISOString = (date) => `${toIsoDatePart(date)}T00:00:00.000Z`;

const toUtcDayEndISOString = (date) => `${toIsoDatePart(date)}T23:59:59.999Z`;

const formatPercent = (value) =>
  value == null ? "0%" : `${Number(value).toFixed(1)}%`;

export const CompanyWiseBreakdown = () => {
  const [select, setSelect] = useState(false);
  const ref = React.useRef(null);
  const [dateRange, setDateRange] = React.useState(null);
  const [csvData, setCsvData] = useState([]);
  const [check, setCheck] = useState({
    company: true,
    totalEmployees: true,
    active: true,
    inactive: true,
    activePercent: true,
    totalPtsEarned: true,
    ptsRedeemed: true,
    balancePts: true,
    totalAdmins: true,
  });

  const closePopup = () => {
    setSelect(false);
  };

  useOutsideClick(ref, closePopup);

  const base = [
    {
      _id: 1,
      link: "/admin/reports",
      label: "Reports",
    },
  ];

  const handleChange = (e) => {
    setCheck({ ...check, [e.target.name]: e.target.checked });
  };

  return (
    <div className="container">
      <BreadcrumbAdmin base={base} page="Company Wise Breakdown" />
      <p className="reportsDetailed__subtitle">
        Totals for the selected company: employees, active and inactive users,
        points earned and redeemed, balance, and admin counts. Active means at
        least one org or company book completed in the last two months.
      </p>
      <div className="reportsDetailed__head">
        <div className="reportsDetailed__headright">
          <DateRangePickerComp
            onChange={(value) => {
              if (!value) {
                setDateRange(null);
              } else {
                const [start, end] = value;
                if (!start || !end) {
                  setDateRange(null);
                  return;
                }
                setDateRange([
                  toUtcDayStartISOString(start),
                  toUtcDayEndISOString(end),
                ]);
              }
            }}
          />
          <div ref={ref} className="reports__selectLayout">
            <Button
              variant="outlined"
              endIcon={
                <ArrowForwardIosIcon
                  sx={{
                    transform: select ? "rotate(-90deg)" : "rotate(90deg)",
                    color: "grey",
                    fontSize: "16px !important",
                  }}
                />
              }
              sx={{
                color: "var(--grey400)",
                borderColor: "var(--grey300)",
                width: "150px",
                fontWeight: "400 !important",
              }}
              onClick={() => setSelect(!select)}
            >
              Manage Field
            </Button>
            <div
              className={select ? "reports__selectActive" : "reports__select"}
            >
              <div className="reports__selectcontent">
                {list.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        checked={Boolean(check[item.name])}
                        name={item.name}
                        onChange={handleChange}
                        sx={{ "& .MuiSvgIcon-root": { fontSize: "20px" } }}
                      />
                    }
                    label={
                      <span style={{ fontSize: "15px" }}>{item.label}</span>
                    }
                  />
                ))}
              </div>
            </div>
          </div>
          <CSVLink filename="Company-wise breakdown" data={csvData}>
            <Button
              variant="contained"
              endIcon={<FileUploadOutlinedIcon sx={{ color: "white" }} />}
            >
              Export
            </Button>
          </CSVLink>
        </div>
      </div>

      <div className="reports__table">
        <CompanyWiseBreakdownTable
          check={check}
          startDate={dateRange && dateRange[0]}
          endDate={dateRange && dateRange[1]}
          getTableData={(data) => {
            const cleanedCSVData = data?.data?.map((obj) => ({
              Company: obj.name,
              "Total Employees": obj.totalEmployees,
              Active: obj.active,
              Inactive: obj.inactive,
              "Active %": formatPercent(obj.activePercent),
              "Total Pts Earned": obj.totalPtsEarned,
              "Pts Redeemed": obj.ptsRedeemed,
              "Balance Pts": obj.balancePts,
              "Total Admins": obj.totalAdmins,
            }));
            setCsvData(cleanedCSVData);
          }}
        />
      </div>
    </div>
  );
};
